var map = {
  "./countries.ar.yml": "76150",
  "./countries.az.yml": "34494",
  "./countries.bg.yml": "11306",
  "./countries.bn.yml": "81163",
  "./countries.by.yml": "75808",
  "./countries.cn.yml": "4968",
  "./countries.cz.yml": "45700",
  "./countries.de.yml": "81054",
  "./countries.dk.yml": "83132",
  "./countries.dz.yml": "57949",
  "./countries.el.yml": "23392",
  "./countries.en.yml": "13798",
  "./countries.es.yml": "94451",
  "./countries.et.yml": "40504",
  "./countries.fi.yml": "52820",
  "./countries.fo.yml": "64910",
  "./countries.fr.yml": "75499",
  "./countries.he.yml": "83482",
  "./countries.hr.yml": "23001",
  "./countries.hu.yml": "25514",
  "./countries.hy.yml": "59574",
  "./countries.id.yml": "88452",
  "./countries.in.yml": "36354",
  "./countries.is.yml": "78247",
  "./countries.it.yml": "45908",
  "./countries.ja.yml": "37328",
  "./countries.ka.yml": "37203",
  "./countries.kl.yml": "48214",
  "./countries.km.yml": "69487",
  "./countries.ko.yml": "1969",
  "./countries.kz.yml": "72492",
  "./countries.lo.yml": "67576",
  "./countries.lt.yml": "99967",
  "./countries.lu.yml": "33926",
  "./countries.lv.yml": "46145",
  "./countries.mk.yml": "91875",
  "./countries.mn.yml": "5582",
  "./countries.mt.yml": "84912",
  "./countries.my.yml": "45845",
  "./countries.ne.yml": "61272",
  "./countries.nl.yml": "63985",
  "./countries.no.yml": "2326",
  "./countries.pl.yml": "78115",
  "./countries.pt.yml": "99851",
  "./countries.ro.yml": "34290",
  "./countries.ru.yml": "19524",
  "./countries.se.yml": "86127",
  "./countries.sl.yml": "53822",
  "./countries.sq.yml": "38203",
  "./countries.sr.yml": "19756",
  "./countries.sw.yml": "32385",
  "./countries.ta.yml": "60058",
  "./countries.tg.yml": "71880",
  "./countries.th.yml": "90811",
  "./countries.tr.yml": "75893",
  "./countries.ua.yml": "28309",
  "./countries.ur.yml": "12474",
  "./countries.uz.yml": "31378",
  "./countries.vi.yml": "7108",
  "./de.yml": "8794",
  "./dk.yml": "52288",
  "./en.yml": "68610",
  "./en_US.yml": "81341",
  "./fi.yml": "23096",
  "./fr.yml": "13791",
  "./no.yml": "51234",
  "./se.yml": "11603"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = function() { return Object.keys(map); };
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 4593;
